// Cart progress bar — refactor da snippets/cart-progress-bar-js.liquid
// inline script. Config letta da data-* su .free-shipping-container.
// Multipli containers (drawer + cart page) vengono aggiornati insieme.

class CartProgressBar {
  constructor() {
    const container = document.querySelector('.free-shipping-container');
    if (!container) return;

    this.threshold = Number(container.dataset.threshold);
    this.locale = container.dataset.locale;
    this.currency = container.dataset.currency;
    this.copyLocked = container.dataset.copyLocked;
    this.copyUnlocked = container.dataset.copyUnlocked;

    this.init();
  }

  formatMoney(cents) {
    return new Intl.NumberFormat(this.locale, {
      style: 'currency',
      currency: this.currency,
    }).format(cents / 100);
  }

  updateProgressBar(cartTotalCents) {
    const remainingCents = Math.max(0, this.threshold - cartTotalCents);
    const percentage = Math.min(100, (cartTotalCents / this.threshold) * 100);
    const qualified = remainingCents === 0;

    const containers = document.querySelectorAll('.free-shipping-container');
    containers.forEach((container) => {
      const textEl = container.querySelector('.amount-remaining-p');
      const bar = container.querySelector('.free-shipping-progress-bar');
      if (!textEl || !bar) return;

      if (qualified) {
        textEl.innerHTML = this.copyUnlocked;
        bar.classList.add('full');
      } else {
        textEl.innerHTML = this.copyLocked.replace('[AMOUNT]', this.formatMoney(remainingCents));
        bar.classList.remove('full');
      }
      bar.style.width = percentage + '%';
    });
  }

  init() {
    if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') {
      console.warn('CartProgressBar: pub/sub system not available');
      return;
    }

    this.unsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.cartData && typeof event.cartData.total_price !== 'undefined') {
        this.updateProgressBar(event.cartData.total_price);
      }
    });
  }

  destroy() {
    if (this.unsubscriber) this.unsubscriber();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.cartProgressBar = new CartProgressBar();
});
